import React, { useState, useEffect, useCallback, lazy, Suspense } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { ThreeDot } from "react-loading-indicators";
import { Tab, Tabs } from "react-bootstrap";
import FilterStore from "../../../../hooks/customHook/FilterStore";

const LocalOverseasExpensesTab = lazy(
  () => import("./LocalOverseasExpensesTab"),
);

const NewLocalExpenses = ({ authrztn }) => {
  const validtabs = ["local", "overseas"];
  const [activeTab, setActiveTab] = useState(() => {
    const saved = FilterStore.getTab();
    return validtabs.includes(saved) ? saved : "local";
  });

  const [currencyId, setCurrencyId] = useState(() =>
    FilterStore.getCurrencyId(),
  );
  const [widgetCurrencySymbol, setWidgetCurrencySymbol] = useState(() =>
    FilterStore.getCurrencyName(),
  );

  useEffect(() => {
    FilterStore.saveCurrencyId(currencyId);
  }, [currencyId]);

  useEffect(() => {
    FilterStore.saveCurrencyName(widgetCurrencySymbol);
  }, [widgetCurrencySymbol]);

  const handleTabSelect = (key) => {
    setActiveTab(key);
    FilterStore.saveTab(key);
  };

  // const localOverseasProps = {
  //   authrztn,
  //   activeTab,
  // };

  return (
    <div className="h-100 w-100 bg-white custom-container">
      <>
        <Suspense
          fallback={
            <div className="loading-container">
              <ThreeDot
                variant="brick-stack"
                color="#6290FE"
                size="large"
                text="Loading Data..."
                textColor=""
              />
            </div>
          }
        >
          {" "}
          <Tabs
            transition={false}
            mountOnEnter
            unmountOnExit={false}
            activeKey={activeTab}
            onSelect={handleTabSelect}
            id="status-tabs"
            className="mb-3"
          >
            <Tab eventKey="local" title="Local">
              {/* <LocalOverseasExpensesTab {...localOverseasProps} /> */}
              <LocalOverseasExpensesTab
                authrztn={authrztn}
                tabType="local"
                isActive={activeTab === "local"}
                currencyId={currencyId}
                setCurrencyId={setCurrencyId}
                widgetCurrencySymbol={widgetCurrencySymbol}
                setWidgetCurrencySymbol={setWidgetCurrencySymbol}
              />
            </Tab>
            <Tab eventKey="overseas" title="Overseas">
              {/* <LocalOverseasExpensesTab {...localOverseasProps} /> */}
              <LocalOverseasExpensesTab
                authrztn={authrztn}
                tabType="overseas"
                isActive={activeTab === "overseas"}
                currencyId={currencyId}
                setCurrencyId={setCurrencyId}
                widgetCurrencySymbol={widgetCurrencySymbol}
                setWidgetCurrencySymbol={setWidgetCurrencySymbol}
              />
            </Tab>
          </Tabs>
        </Suspense>
      </>
    </div>
  );
};

export default NewLocalExpenses;
